import { render, staticRenderFns } from "./UserBankDetails.vue?vue&type=template&id=5d8eac4e"
import script from "./UserBankDetails.vue?vue&type=script&lang=js"
export * from "./UserBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports